import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.list`;

export const INIT = `${SCOPE}/INIT`;
export const GET_DASHBOARDS_LIST = `${SCOPE}/GET_DASHBOARDS_LIST`;
